"use strict";
var forms_1 = require('@angular/forms');
var lang_1 = require('../facade/lang');
exports.digits = function (control) {
    if (lang_1.isPresent(forms_1.Validators.required(control)))
        return null;
    var v = control.value;
    return /^\d+$/.test(v) ? null : { digits: true };
};
//# sourceMappingURL=validator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-validation/dist/digits/validator.js
// module id = 1147
// module chunks = 10